import React from "react";

export const PathTypeContext = React.createContext({});
